function calcularTempoRestante(prazoMinutos, createdAt) {
  const agora = new Date();
  const dataCriacao = new Date(createdAt);

  const diferencaMs = agora - dataCriacao;
  const minutosPassados = Math.floor(diferencaMs / 60000);

  const minutosRestantes = prazoMinutos - minutosPassados;

  return minutosRestantes > 0 ? minutosRestantes : 0;
}

export default calcularTempoRestante;
